module.exports = __webpack_public_path__ + "img/logo.86f49068.png";